package com.sweetlime.dungeonamigo.model

import com.sweetlime.dungeonamigo.util.LongAsDoubleSerializer
import kotlinx.serialization.Serializable

@Serializable
data class DmEntity(
    val id: String = "",
    val roomId: String = "",
    val name: String = "",
    val sourceType: DmEntitySource = DmEntitySource.HOMEBREW,
    val monsterSlug: String? = null,

    val maxHp: Int = 0,
    val currentHp: Int = 0,
    val temporaryHp: Int = 0,
    val armorClass: Int = 10,
    val speed: Int = 30,
    val initiative: Int = 0,
    val initiativeRoll: Int = 0,

    val strength: Int = 10,
    val dexterity: Int = 10,
    val constitution: Int = 10,
    val intelligence: Int = 10,
    val wisdom: Int = 10,
    val charisma: Int = 10,

    val challengeRating: String = "",
    val type: String = "",
    val conditions: List<String> = emptyList(),
    val notes: String = "",

    val isDefeated: Boolean = false,
    @Serializable(with = LongAsDoubleSerializer::class)
    val createdAt: Long = 0,
)

@Serializable
enum class DmEntitySource { COMPENDIUM, HOMEBREW }
